// The items an invoice bills or a refund takes off, as staff edit them (USA-378).

export type Line = { key: number; description: string; quantity: string; unitPrice: string }

const MONEY = /^-?\d+(\.\d{1,2})?$/
const QUANTITY = /^\d+(\.\d{1,2})?$/

/** A line's amount in cents, or null while its quantity or price is not a number. */
export function lineCents(line: Line) {
  if (!QUANTITY.test(line.quantity.trim()) || !MONEY.test(line.unitPrice.trim())) return null
  return Math.round(Number(line.quantity) * Number(line.unitPrice) * 100)
}

/** A money amount staff typed, in cents; null when it is not a non-negative amount. */
export function moneyCents(value: string) {
  return /^\d+(\.\d{1,2})?$/.test(value.trim()) ? Math.round(Number(value) * 100) : null
}

export function lineValid(line: Line, { positive = false } = {}) {
  const amount = lineCents(line)
  return line.description.trim() !== '' && Number(line.quantity) > 0 && amount !== null && (!positive || amount > 0)
}

let nextKey = 1
export const blankLine = (): Line => ({ key: nextKey++, description: '', quantity: '1', unitPrice: '' })

export const pickedLine = (description: string, quantity: string | number, unitPrice: string | number): Line => ({
  key: nextKey++,
  description,
  quantity: String(Number(quantity)),
  unitPrice: Number(unitPrice).toFixed(2),
})
